import { getLoggerService } from '@/modules/logger/infrastructure/loggerService';
import { COOKIES } from '@/services/constants';

export default async function ({ $cookies, route }) {
  const lang = route.query.lang || $cookies.get(COOKIES.lang) || '';

  if (lang) {
    try {
      $cookies.set(COOKIES.lang, lang, {
        maxAge: 60 * 60 * 24 * 7,
        path: '/',
        secure: process.env.NODE_ENV !== 'development',
      });
    } catch (err) {
      const { logger } = getLoggerService();
      logger.error('Failed to set lang cookie', { error: err.message, lang });
    }
  }
}
